export default __webpack_public_path__ + "static/media/Indonesia.1ea4ce7d.svg";